import { createActions } from 'redux-actions'

export const INIT_BRANCH_LIST_INFO = "INIT_BRANCH_LIST_INFO";

export const REQUEST_BRANCH_DETAIL_START = "REQUEST_BRANCH_DETAIL_START";
export const REQUEST_BRANCH_DETAIL_SUCCESS = "REQUEST_BRANCH_DETAIL_SUCCESS";
export const REQUEST_BRANCH_DETAIL_FAIL = "REQUEST_BRANCH_DETAIL_FAIL";

export const SEARCH_BRANCH_LIST_START = "SEARCH_BRANCH_LIST_START";
export const SEARCH_BRANCH_LIST_SUCCESS = "SEARCH_BRANCH_LIST_SUCCESS";
export const SEARCH_BRANCH_LIST_FAIL = "SEARCH_BRANCH_LIST_FAIL";

export const REQUEST_BRANCH_LIST_START = "REQUEST_BRANCH_LIST_START";
export const REQUEST_BRANCH_LIST_SUCCESS = "REQUEST_BRANCH_LIST_SUCCESS";
export const REQUEST_BRANCH_LIST_FAIL = "REQUEST_BRANCH_LIST_FAIL";

export const REQUEST_BRANCH_CATE_START = "REQUEST_BRANCH_CATE_START";
export const REQUEST_BRANCH_CATE_SUCCESS = "REQUEST_BRANCH_CATE_SUCCESS";
export const REQUEST_BRANCH_CATE_FAIL = "REQUEST_BRANCH_CATE_FAIL";

export const REQUEST_LIST_CATE_BRANCH_START = "REQUEST_LIST_CATE_BRANCH_START";
export const REQUEST_LIST_CATE_BRANCH_SUCCESS = "REQUEST_LIST_CATE_BRANCH_SUCCESS";
export const REQUEST_LIST_CATE_BRANCH_FAIL = "REQUEST_LIST_CATE_BRANCH_FAIL";

export const ADD_BRANCH_CATE_START = "ADD_BRANCH_CATE_START";
export const ADD_BRANCH_CATE_SUCCESS = "ADD_BRANCH_CATE_SUCCESS";
export const ADD_BRANCH_CATE_FAIL = "ADD_BRANCH_CATE_FAIL";

export const DELETE_BRANCH_CATE_START = "DELETE_BRANCH_CATE_START";
export const DELETE_BRANCH_CATE_SUCCESS = "DELETE_BRANCH_CATE_SUCCESS";
export const DELETE_BRANCH_CATE_FAIL = "DELETE_BRANCH_CATE_FAIL";

export const ADD_MAP_CATE_BRANCH_START = "ADD_MAP_CATE_BRANCH_START";
export const ADD_MAP_CATE_BRANCH_SUCCESS = "ADD_MAP_CATE_BRANCH_SUCCESS";
export const ADD_MAP_CATE_BRANCH_FAIL = "ADD_MAP_CATE_BRANCH_FAIL";

export const DELETE_MAP_CATE_BRANCH_START = "DELETE_MAP_CATE_BRANCH_START";
export const DELETE_MAP_CATE_BRANCH_SUCCESS = "DELETE_MAP_CATE_BRANCH_SUCCESS";
export const DELETE_MAP_CATE_BRANCH_FAIL = "DELETE_MAP_CATE_BRANCH_FAIL";

export const MAP_PRODUCT_BRANCH_START = "MAP_PRODUCT_BRANCH_START";
export const MAP_PRODUCT_BRANCH_SUCCESS = "MAP_PRODUCT_BRANCH_SUCCESS";
export const MAP_PRODUCT_BRANCH_FAIL = "MAP_PRODUCT_BRANCH_FAIL";

export const MAP_PRODUCT_BRANCH_LIST_START = "MAP_PRODUCT_BRANCH_LIST_START";
export const MAP_PRODUCT_BRANCH_LIST_SUCCESS = "MAP_PRODUCT_BRANCH_LIST_SUCCESS";
export const MAP_PRODUCT_BRANCH_LIST_FAIL = "MAP_PRODUCT_BRANCH_LIST_FAIL";

export const MAP_PRODUCT_BRANCH_DETAIL_START = "MAP_PRODUCT_BRANCH_DETAIL_START";
export const MAP_PRODUCT_BRANCH_DETAIL_SUCCESS = "MAP_PRODUCT_BRANCH_DETAIL_SUCCESS";
export const MAP_PRODUCT_BRANCH_DETAIL_FAIL = "MAP_PRODUCT_BRANCH_DETAIL_FAIL";

export const IMPORT_PRODUCT_BRANCH_START = "IMPORT_PRODUCT_BRANCH_START";
export const IMPORT_PRODUCT_BRANCH_SUCCESS = "IMPORT_PRODUCT_BRANCH_SUCCESS";
export const IMPORT_PRODUCT_BRANCH_FAIL = "IMPORT_PRODUCT_BRANCH_FAIL";

export const REQUEST_IMPORT_PRODUCT_BRANCH_START = "REQUEST_IMPORT_PRODUCT_BRANCH_START";
export const REQUEST_IMPORT_PRODUCT_BRANCH_SUCCESS = "REQUEST_IMPORT_PRODUCT_BRANCH_SUCCESS";
export const REQUEST_IMPORT_PRODUCT_BRANCH_FAIL = "REQUEST_IMPORT_PRODUCT_BRANCH_FAIL";

export const REQUEST_LIST_BRANCH_PRODUCT_START = "REQUEST_LIST_BRANCH_PRODUCT_START";
export const REQUEST_LIST_BRANCH_PRODUCT_SUCCESS = "REQUEST_LIST_BRANCH_PRODUCT_SUCCESS";
export const REQUEST_LIST_BRANCH_PRODUCT_FAIL = "REQUEST_LIST_BRANCH_PRODUCT_FAIL";

export const REQUEST_LIST_BRANCH_FILTER_START = "REQUEST_LIST_BRANCH_FILTER_START";
export const REQUEST_LIST_BRANCH_FILTER_SUCCESS = "REQUEST_LIST_BRANCH_FILTER_SUCCESS";
export const REQUEST_LIST_BRANCH_FILTER_FAIL = "REQUEST_LIST_BRANCH_FILTER_FAIL";

export const REQUEST_BRANCH_LIST_HIERARCHY_START = "REQUEST_BRANCH_LIST_HIERARCHY_START";
export const REQUEST_BRANCH_LIST_HIERARCHY_SUCCESS = "REQUEST_BRANCH_LIST_HIERARCHY_SUCCESS";
export const REQUEST_BRANCH_LIST_HIERARCHY_FAIL = "REQUEST_BRANCH_LIST_HIERARCHY_FAIL";

export const REQUEST_BRANCH_TYPE_LIST_START = "REQUEST_BRANCH_TYPE_LIST_START";
export const REQUEST_BRANCH_TYPE_LIST_SUCCESS = "REQUEST_BRANCH_TYPE_LIST_SUCCESS";
export const REQUEST_BRANCH_TYPE_LIST_FAIL = "REQUEST_BRANCH_TYPE_LIST_FAIL";

export const REQUEST_BRANCH_TAG_LIST_START = "REQUEST_BRANCH_TAG_LIST_START";
export const REQUEST_BRANCH_TAG_LIST_SUCCESS = "REQUEST_BRANCH_TAG_LIST_SUCCESS";
export const REQUEST_BRANCH_TAG_LIST_FAIL = "REQUEST_BRANCH_TAG_LIST_FAIL";

export const REQUEST_BRANCH_CATEGORY_LIST_START = "REQUEST_BRANCH_CATEGORY_LIST_START";
export const REQUEST_BRANCH_CATEGORY_LIST_SUCCESS = "REQUEST_BRANCH_CATEGORY_LIST_SUCCESS";
export const REQUEST_BRANCH_CATEGORY_LIST_FAIL = "REQUEST_BRANCH_CATEGORY_LIST_FAIL";

export const REQUEST_BRANCH_ACTIVE_LIST_START = "REQUEST_BRANCH_ACTIVE_LIST_START";
export const REQUEST_BRANCH_ACTIVE_LIST_SUCCESS = "REQUEST_BRANCH_ACTIVE_LIST_SUCCESS";
export const REQUEST_BRANCH_ACTIVE_LIST_FAIL = "REQUEST_BRANCH_ACTIVE_LIST_FAIL";

export const REQUEST_BRANCH_PAGE_LIST_START = "REQUEST_BRANCH_PAGE_LIST_START";
export const REQUEST_BRANCH_PAGE_LIST_SUCCESS = "REQUEST_BRANCH_PAGE_LIST_SUCCESS";
export const REQUEST_BRANCH_PAGE_LIST_FAIL = "REQUEST_BRANCH_PAGE_LIST_FAIL";

export const REQUEST_PAGE_ADD_BRANCH_START = "REQUEST_PAGE_ADD_BRANCH_START";
export const REQUEST_PAGE_ADD_BRANCH_SUCCESS = "REQUEST_PAGE_ADD_BRANCH_SUCCESS";
export const REQUEST_PAGE_ADD_BRANCH_FAIL = "REQUEST_PAGE_ADD_BRANCH_FAIL";

export const REQUEST_PAGE_DELETE_BRANCH_START = "REQUEST_PAGE_DELETE_BRANCH_START";
export const REQUEST_PAGE_DELETE_BRANCH_SUCCESS = "REQUEST_PAGE_DELETE_BRANCH_SUCCESS";
export const REQUEST_PAGE_DELETE_BRANCH_FAIL = "REQUEST_PAGE_DELETE_BRANCH_FAIL";

export const REQUEST_UPDATE_PAGE_BRANCH_START = "REQUEST_UPDATE_PAGE_BRANCH_START";

export const {

  initBranchListInfo,

  requestBranchDetailStart,
  requestBranchDetailSuccess,
  requestBranchDetailFail,

  searchBranchListStart,
  searchBranchListSuccess,
  searchBranchListFail,

  requestBranchListStart,
  requestBranchListSuccess,
  requestBranchListFail,

  requestBranchCateStart,
  requestBranchCateSuccess,
  requestBranchCateFail,

  requestListCateBranchStart,
  requestListCateBranchSuccess,
  requestListCateBranchFail,

  addBranchCateStart,
  addBranchCateSuccess,
  addBranchCateFail,

  deleteBranchCateStart,
  deleteBranchCateSuccess,
  deleteBranchCateFail,

  addMapCateBranchStart,
  addMapCateBranchSuccess,
  addMapCateBranchFail,

  deleteMapCateBranchStart,
  deleteMapCateBranchSuccess,
  deleteMapCateBranchFail,

  mapProductBranchStart,
  mapProductBranchSuccess,
  mapProductBranchFail,

  mapProductBranchListStart,
  mapProductBranchListSuccess,
  mapProductBranchListFail,

  mapProductBranchDetailStart,
  mapProductBranchDetailSuccess,
  mapProductBranchDetailFail,

  importProductBranchStart,
  importProductBranchSuccess,
  importProductBranchFail,

  requestImportProductBranchStart,
  requestImportProductBranchSuccess,
  requestImportProductBranchFail,

  requestListBranchProductStart,
  requestListBranchProductSuccess,
  requestListBranchProductFail,

  requestListBranchFilterStart,
  requestListBranchFilterSuccess,
  requestListBranchFilterFail,

  requestBranchListHierarchyStart,
  requestBranchListHierarchySuccess,
  requestBranchListHierarchyFail,

  requestBranchTypeListStart,
  requestBranchTypeListSuccess,
  requestBranchTypeListFail,

  requestBranchTagListStart,
  requestBranchTagListSuccess,
  requestBranchTagListFail,

  requestBranchCategoryListStart,
  requestBranchCategoryListSuccess,
  requestBranchCategoryListFail,

  requestBranchActiveListStart,
  requestBranchActiveListSuccess,
  requestBranchActiveListFail,

  requestBranchPageListStart,
  requestBranchPageListSuccess,
  requestBranchPageListFail,

  requestPageAddBranchStart,
  requestPageAddBranchSuccess,
  requestPageAddBranchFail,

  requestPageDeleteBranchStart,
  requestPageDeleteBranchSuccess,
  requestPageDeleteBranchFail,

  requestUpdatePageBranchStart,

} = createActions({

  [INIT_BRANCH_LIST_INFO]: (req) => ({ req }),

  [REQUEST_BRANCH_DETAIL_START]: (req) => ({ ...req }),
  [REQUEST_BRANCH_DETAIL_SUCCESS]: (res) => ({ res }),
  [REQUEST_BRANCH_DETAIL_FAIL]: (res) => ({ res }),

  [SEARCH_BRANCH_LIST_START]: (req) => ({ ...req }),
  [SEARCH_BRANCH_LIST_SUCCESS]: (res) => ({ res }),
  [SEARCH_BRANCH_LIST_FAIL]: (res) => ({ res }),

  [REQUEST_BRANCH_LIST_START]: (req) => ({ ...req }),
  [REQUEST_BRANCH_LIST_SUCCESS]: (res) => ({ res }),
  [REQUEST_BRANCH_LIST_FAIL]: (res) => ({ res }),

  [REQUEST_BRANCH_CATE_START]: (req) => ({ ...req }),
  [REQUEST_BRANCH_CATE_SUCCESS]: (res) => ({ res }),
  [REQUEST_BRANCH_CATE_FAIL]: (res) => ({ res }),

  [REQUEST_LIST_CATE_BRANCH_START]: (req) => ({ ...req }),
  [REQUEST_LIST_CATE_BRANCH_SUCCESS]: (res) => ({ res }),
  [REQUEST_LIST_CATE_BRANCH_FAIL]: (res) => ({ res }),

  [ADD_BRANCH_CATE_START]: (req) => ({ ...req }),
  [ADD_BRANCH_CATE_SUCCESS]: (res) => ({ res }),
  [ADD_BRANCH_CATE_FAIL]: (res) => ({ res }),

  [DELETE_BRANCH_CATE_START]: (req) => ({ ...req }),
  [DELETE_BRANCH_CATE_SUCCESS]: (res) => ({ res }),
  [DELETE_BRANCH_CATE_FAIL]: (res) => ({ res }),

  [ADD_MAP_CATE_BRANCH_START]: (req) => ({ ...req }),
  [ADD_MAP_CATE_BRANCH_SUCCESS]: (res) => ({ res }),
  [ADD_MAP_CATE_BRANCH_FAIL]: (res) => ({ res }),

  [DELETE_MAP_CATE_BRANCH_START]: (req) => ({ ...req }),
  [DELETE_MAP_CATE_BRANCH_SUCCESS]: (res) => ({ res }),
  [DELETE_MAP_CATE_BRANCH_FAIL]: (res) => ({ res }),

  [MAP_PRODUCT_BRANCH_START]: (req) => ({ ...req }),
  [MAP_PRODUCT_BRANCH_SUCCESS]: (res) => ({ res }),
  [MAP_PRODUCT_BRANCH_FAIL]: (res) => ({ res }),

  [MAP_PRODUCT_BRANCH_LIST_START]: (req) => ({ ...req }),
  [MAP_PRODUCT_BRANCH_LIST_SUCCESS]: (res) => ({ res }),
  [MAP_PRODUCT_BRANCH_LIST_FAIL]: (res) => ({ res }),

  [MAP_PRODUCT_BRANCH_DETAIL_START]: (req) => ({ ...req }),
  [MAP_PRODUCT_BRANCH_DETAIL_SUCCESS]: (res) => ({ res }),
  [MAP_PRODUCT_BRANCH_DETAIL_FAIL]: (res) => ({ res }),

  [IMPORT_PRODUCT_BRANCH_START]: (req) => ({ ...req }),
  [IMPORT_PRODUCT_BRANCH_SUCCESS]: (res) => ({ res }),
  [IMPORT_PRODUCT_BRANCH_FAIL]: (res) => ({ res }),

  [REQUEST_IMPORT_PRODUCT_BRANCH_START]: (req) => ({ ...req }),
  [REQUEST_IMPORT_PRODUCT_BRANCH_SUCCESS]: (res) => ({ res }),
  [REQUEST_IMPORT_PRODUCT_BRANCH_FAIL]: (res) => ({ res }),

  [REQUEST_LIST_BRANCH_PRODUCT_START]: (req) => ({ ...req }),
  [REQUEST_LIST_BRANCH_PRODUCT_SUCCESS]: (res) => ({ res }),
  [REQUEST_LIST_BRANCH_PRODUCT_FAIL]: (res) => ({ res }),

  [REQUEST_LIST_BRANCH_FILTER_START]: (req) => ({ ...req }),
  [REQUEST_LIST_BRANCH_FILTER_SUCCESS]: (res) => ({ res }),
  [REQUEST_LIST_BRANCH_FILTER_FAIL]: (res) => ({ res }),

  [REQUEST_BRANCH_LIST_HIERARCHY_START]: (req) => ({ ...req }),
  [REQUEST_BRANCH_LIST_HIERARCHY_SUCCESS]: (res) => ({ res }),
  [REQUEST_BRANCH_LIST_HIERARCHY_FAIL]: (res) => ({ res }),

  [REQUEST_BRANCH_TYPE_LIST_START]: (req) => ({ ...req }),
  [REQUEST_BRANCH_TYPE_LIST_SUCCESS]: (res) => ({ res }),
  [REQUEST_BRANCH_TYPE_LIST_FAIL]: (res) => ({ res }),

  [REQUEST_BRANCH_TAG_LIST_START]: (req) => ({ ...req }),
  [REQUEST_BRANCH_TAG_LIST_SUCCESS]: (res) => ({ res }),
  [REQUEST_BRANCH_TAG_LIST_FAIL]: (res) => ({ res }),

  [REQUEST_BRANCH_CATEGORY_LIST_START]: (req) => ({ ...req }),
  [REQUEST_BRANCH_CATEGORY_LIST_SUCCESS]: (res) => ({ res }),
  [REQUEST_BRANCH_CATEGORY_LIST_FAIL]: (res) => ({ res }),

  [REQUEST_BRANCH_ACTIVE_LIST_START]: (req) => ({ ...req }),
  [REQUEST_BRANCH_ACTIVE_LIST_SUCCESS]: (res) => ({ res }),
  [REQUEST_BRANCH_ACTIVE_LIST_FAIL]: (res) => ({ res }),

  [REQUEST_BRANCH_PAGE_LIST_START]: (req) => ({ ...req }),
  [REQUEST_BRANCH_PAGE_LIST_SUCCESS]: (res) => ({ res }),
  [REQUEST_BRANCH_PAGE_LIST_FAIL]: (res) => ({ res }),

  [REQUEST_PAGE_ADD_BRANCH_START]: (req) => ({ ...req }),
  [REQUEST_PAGE_ADD_BRANCH_SUCCESS]: (res) => ({ res }),
  [REQUEST_PAGE_ADD_BRANCH_FAIL]: (res) => ({ res }),

  [REQUEST_PAGE_DELETE_BRANCH_START]: (req) => ({ ...req }),
  [REQUEST_PAGE_DELETE_BRANCH_SUCCESS]: (res) => ({ res }),
  [REQUEST_PAGE_DELETE_BRANCH_FAIL]: (res) => ({ res }),

  [REQUEST_UPDATE_PAGE_BRANCH_START]: (req) => ({ ...req }),
})

